// Mobile Actions
export const MOBILE_SIDEBAR_OPEN = 'MOBILE_SIDEBAR_OPEN';
export const MOBILE_SIDEBAR_CLOSE = 'MOBILE_SIDEBAR_CLOSE';
export const SCREEN_RESIZE = 'SCREEN_RESIZE';

// User Actions
export const USER_DETAILS_FETCHED = 'USER_DETAILS_FETCHED';
export const USER_STATIONS_FETCHED = 'USER_STATIONS_FETCHED';
export const USER_ZONES_FETCHED = 'USER_ZONES_FETCHED';
export const USER_AREAS_FETCHED = 'USER_AREAS_FETCHED';

// Site Visits Actions
export const SELECTED_STATION='SELECTED_STATION';
export const CLEAR_STATION_SELECTION='CLEAR_STATION_SELECTION';
export const SELECTED_NOTES='SELECTED_NOTES';
export const RECEIVED_NOTES='RECEIVED_NOTES';
export const CATEGORIES_FETCHED='CATEGORIES_FETCHED';
export const LAST_VISIT_INFO = 'LAST_VISIT_INFO';
export const FETCHING_DATA = 'FETCHING_DATA';
export const CHECK_IN ='CHECK_IN';

//Notes Actions
export const SHOW_NEW_NOTE = 'SHOW_NEW_NOTE';
export const EDIT_NOTE ='EDIT_NOTE';

//Navigation Actions
export const SELECTED_AREA='SELECTED_AREA';
export const SELECTED_ZONE='SELECTED_ZONE';
export const SELECTED_NAV_STATION='SELECTED_STATION';
export const AREAS_FETCHED = 'AREAS_FETCHED';
export const ZONES_FETCHED ='ZONES_FETCHED';
export const FETCHED_STATIONS='FETCHED_STATIONS';
export const FILTERS_FETCHED='FILTERS_FETCHED';

//Button Actions
export const ACCEPT_NOTE='ACCEPT_NOTE';
export const DELETE_NOTE='DELETE_NOTE';
export const SHARE_NOTE='SHARE_NOTE';

//Stations
export const USER_SELECTED_ZONE='USER_SELECTED_ZONE';
export const USER_SELECTED_AREA='USER_SELECTED_AREA';
export const USER_SELECTED_STATION='USER_SELECTED_STATION';
export const USER_FILTERED_STATION='USER_FILTERED_STATION';
export const USER_FILTERED_ZONE='USER_FILTERED_ZONE';
export const USER_FILTERED_AREA='USER_FILTERED_AREA';
export const CLEAR_ZONE_SELECTION = 'CLEAR_ZONE_SELECTION';
export const CLEAR_AREA_SELECTION = 'CLEAR_AREA_SELECTION';

//Selectors
export const FILTER_CATEGORIES = 'FILTER_CATEGORIES';


// WEBPACK FOOTER //
// ./src/actions/types.js